const HeaderMobile = {
  el: {
    header: document.querySelector('.header-mobile'),
    headerNav: document.querySelector('.header-mobile .header__nav'),
    menuButton: document.querySelector('.header-mobile .header__menubutton'),
    closeButton: document.querySelector('.header-mobile .header__menuclose'),
    menuItems: document.querySelectorAll('.header-mobile .header__item'),
    alertBanner: document.querySelector<HTMLDivElement>('.alert-banner'),
  },
  init() {
    if (!this.el.menuButton) {
      return
    }

    if (this.el.alertBanner && this.el.alertBanner.classList.contains('hidden') === false) {
      this.el.header.classList.add('absolute')
      this.el.header.classList.remove('fixed')
      document.addEventListener('scroll', () => {
        if (this.el.alertBanner && window.scrollY > this.el.alertBanner.offsetHeight) {
          this.el.header.classList.add('fixed')
          this.el.header.classList.remove('absolute')
          this.el.header.classList.add('top-0')
        } else {
          this.el.header.classList.add('absolute')
          this.el.header.classList.remove('fixed')
          this.el.header.classList.remove('top-0')
        }
      })
    }

    this.el.menuButton.addEventListener('click', () => {
      this.el.headerNav.classList.remove('hidden')

      setTimeout(() => {
        this.el.header.classList.add('header-mobile--open')
        this.el.menuButton.classList.add('hidden')
        this.el.closeButton.classList.toggle('hidden')
      }, 0)
    })

    this.el.closeButton.addEventListener('click', () => {
      this.el.header.classList.remove('header-mobile--open')
      this.el.closeButton.classList.add('hidden')
      this.el.menuButton.classList.remove('hidden')

      setTimeout(() => {
        this.el.headerNav.classList.add('hidden')
      }, 400)
    })

    this.el.menuItems.forEach((item) => {
      const subMenu = item.querySelector('.header-mobile__subcontainer')
      const subButton = item.querySelector('.header-mobile__opensub')

      if (!(subMenu || subButton)) {
        return
      }
      subButton.addEventListener('click', () => {
        console.log(subButton, subMenu)
        subMenu.classList.toggle('header-mobile__subcontainer--open')
        subButton.classList.toggle('header-mobile__opensub--open')
      })
    })
  },
}

export default HeaderMobile
